<template>
    <Breadcrumbs main="Form Layout" title="Form Wizard" />
    <div class="container-fluid">
        <div class="row">
            <simpleWizard />
            <shippingForm />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const shippingForm = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard/shippingForm.vue"))
const simpleWizard = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard/simpleWizard.vue"))
</script>